import { render, staticRenderFns } from "./PlayerPenalty.vue?vue&type=template&id=94cc0914&scoped=true"
import script from "./PlayerPenalty.vue?vue&type=script&lang=js"
export * from "./PlayerPenalty.vue?vue&type=script&lang=js"
import style0 from "./PlayerPenalty.vue?vue&type=style&index=0&id=94cc0914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cc0914",
  null
  
)

export default component.exports